import { render, staticRenderFns } from "./RadioSwitch.vue?vue&type=template&id=2fbb91e4&"
import script from "./RadioSwitch.vue?vue&type=script&lang=js&"
export * from "./RadioSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports